import { IOrgCityListResponseData } from "@/api_framework/api_modals/Org";
import { ISlotsAddressOption } from "@/app/components/routes/auth_routes/SlotsScreen/BookingFiltersComponent/interface";

export const mapAddressToGeoOption = (address: ISlotsAddressOption) => {
  return {
    title: address?.address_2,
    checkboxVisible: true,
    id: address?.address_id,
    address_id: address?.address_id,
    address_1: address?.address_1,
    address_2: address?.address_2,
    label: address?.label,
    previously_ordered: address?.previously_ordered,
    withSubItems: false,
    subSelectItems: [],
    state: {
      formattedAddress: address?.address_2,
      city: address?.city,
      state: address?.state,
      placeId: null,
      pincode: address?.pincode,
      lat: address?.latitude,
      long: address?.longitude,
    },
  };
};

export const normalizeCityName = (name?: string) =>
  (name ?? "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

export type CityByNormalizedName = Map<string, { id: string; name: string }>;

export const buildCityByNormalizedName = (
  cities?: IOrgCityListResponseData[] | null,
): CityByNormalizedName => {
  const cityMap: CityByNormalizedName = new Map();
  (cities ?? []).forEach((city) => {
    if (!city?.id || !city?.name) return;
    cityMap.set(normalizeCityName(city.name), { id: city.id, name: city.name });
  });
  return cityMap;
};

export const getLinkedCityIdsFromAPI = (
  selectedCityId: string,
  cities?: IOrgCityListResponseData[] | null,
  cityByNormalizedName?: CityByNormalizedName,
): string[] => {
  const normalizedSelectedCityId = String(selectedCityId);
  const selectedCity = (cities ?? []).find((city) => String(city?.id) === normalizedSelectedCityId);
  if (!selectedCity?.name) return [];
  const selectedCityKey = normalizeCityName(selectedCity.name);
  if (selectedCityKey !== "delhi" && selectedCityKey !== "doggyworld") return [];
  const targetCityKey = selectedCityKey === "delhi" ? "doggyworld" : "delhi";
  const targetCityId = cityByNormalizedName?.get(targetCityKey)?.id;
  return targetCityId ? [targetCityId] : [];
};

export const getVisibleCityIdFromFilter = (cityId?: string | string[] | null) => {
  if (Array.isArray(cityId)) return cityId?.[0] ? String(cityId[0]) : "";
  if (typeof cityId === "string") return String(cityId);
  return "";
};

export const isSelectedCityIncludedInFilter = (selectedCityId: string, cityId?: string | string[] | null) => {
  if (!selectedCityId) return false;
  const normalizedSelectedCityId = String(selectedCityId);
  if (Array.isArray(cityId)) return cityId.map((id) => String(id)).includes(normalizedSelectedCityId);
  if (typeof cityId === "string") return String(cityId) === normalizedSelectedCityId;
  return false;
};

export const getCityIdsForPayload = (
  selectedCityId: string,
  cities?: IOrgCityListResponseData[] | null,
  cityByNormalizedName?: CityByNormalizedName,
): string[] | null => {
  if (!selectedCityId) return null;
  const normalizedSelectedCityId = String(selectedCityId);
  const linkedCityIds = getLinkedCityIdsFromAPI(normalizedSelectedCityId, cities, cityByNormalizedName).map((id) =>
    String(id),
  );
  return Array.from(new Set([normalizedSelectedCityId, ...linkedCityIds]));
};
